import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"white data-inline-content",attrs:{"fluid":""}},[_c('div',{staticClass:"qmkey-related-inline-table"},[_c(VDataTable,{staticClass:"qmkey-explorer-table-expansion-table",attrs:{"headers":_vm.columns,"items":_vm.current_qunit[_vm.props.attr],"item-key":"uid","dense":"","sort-by":"version","must-sort":"","sort-desc":""},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
var item = ref.item;
return [(item.date)?_c('span',[_vm._v("\n        "+_vm._s(new Date(item.date).toLocaleDateString(undefined, {
            // weekday: 'long',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          }))+"\n      ")]):_vm._e()]}}],null,true)})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }